module.exports = __webpack_public_path__ + "img/samalife.4d60f8b8.jpg";